import React from "react";
import mvImg1 from "../../images/election-mission/1.jpg";
import mvImg2 from "../../images/election-mission/2.jpg";
import mvImg3 from "../../images/election-mission/3.jpg";
import mvImg4 from "../../images/election-mission/4.jpg";
import mvImg5 from "../../images/election-mission/5.jpg";
import mvImg6 from "../../images/election-mission/6.jpg";
import mvImg7 from "../../images/election-mission/7.jpg";
import mvImg8 from "../../images/election-mission/8.jpg";

const Mission = [
  {
    id: "01",
    mImg: mvImg1,
    Title: "COMMUNITY EMPOWERMENT & ENGAGEMENT",
    Des: "Empowering residents through engagement and transparent communication, ensuring that every voice is heard and every concern addressed.",
  },
  {
    id: "02",
    mImg: mvImg2,
    Title: "ECONOMIC DEVELOPMENT & JOB CREATION",
    Des: "Advocating for policies that support small businesses, attract new industries, and create sustainable job opportunities to spur economic growth.",
  },
  {
    id: "03",
    mImg: mvImg3,
    Title: "EDUCATION & YOUTH EMPOWERMENT",
    Des: "Championing initiatives to provide youth with tools for success, including mentorship programs, vocational training, and after-school activities.",
  },
  {
    id: "04",
    mImg: mvImg4,
    Title: "PUBLIC SAFETY & JUSTICE",
    Des: "Strengthening public safety measures and advocating for criminal justice reform to ensure safe, just, and equitable neighborhoods.",
  },
  {
    id: "05",
    mImg: mvImg5,
    Title: "HEALTHCARE & SOCIAL SERVICES",
    Des: "Expanding access to quality healthcare, mental health services, and social support programs, addressing root causes of health disparities.",
  },
  {
    id: "06",
    mImg: mvImg6,
    Title: "ENVIRONMENTAL SUSTAINABILITY",
    Des: "Promoting green infrastructure, renewable energy, and conservation efforts to make the district a model for environmental stewardship.",
  },
  {
    id: "07",
    mImg: mvImg7,
    Title: "TRANSPORTATION & INFRASTRUCTURE",
    Des: "Improving public transportation and infrastructure to enhance connectivity and accessibility for all residents, ensuring efficient services.",
  },
  {
    id: "08",
    mImg: mvImg8,
    Title: "GOVERNMENT TRANSPARENCY & ACCOUNTABILITY",
    Des: "Prioritizing open communication and making government processes accessible, ensuring decisions reflect the community's needs and wants.",
  },
];

const MissionVission = (props) => {
  return (
    <section className="wpo-election-mission-section section-padding">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col col-lg-6 col-md-8 col-12">
            <div className="wpo-section-title">
              <div className="section-titl-shape-1">
                <svg width="687" height="473" viewBox="0 0 687 473" fill="none">
                  <g opacity="0.44" filter="url(#filter0_f_1_1040)">
                    <circle cx="343.5" cy="129.5" r="129.5" />
                  </g>
                  <defs>
                    <filter
                      id="filter0_f_1_1040"
                      x="0"
                      y="-214"
                      width="687"
                      height="687"
                      filterUnits="userSpaceOnUse"
                      colorInterpolationFilters="sRGB"
                    >
                      <feFlood floodOpacity="0" result="BackgroundImageFix" />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                      />
                      <feGaussianBlur
                        stdDeviation="107"
                        result="effect1_foregroundBlur_1_104"
                      />
                    </filter>
                  </defs>
                </svg>
              </div>
              <div className="section-titl-shape-2">
                <svg width="687" height="473" viewBox="0 0 687 473" fill="none">
                  <g opacity="0.44" filter="url(#filter0_f_1_105)">
                    <circle cx="343.5" cy="129.5" r="129.5" />
                  </g>
                  <defs>
                    <filter
                      id="filter0_f_1_105"
                      x="0"
                      y="-214"
                      width="687"
                      height="687"
                      filterUnits="userSpaceOnUse"
                      colorInterpolationFilters="sRGB"
                    >
                      <feFlood floodOpacity="0" result="BackgroundImageFix" />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                      />
                      <feGaussianBlur
                        stdDeviation="107"
                        result="effect1_foregroundBlur_1_105"
                      />
                    </filter>
                  </defs>
                </svg>
              </div>
              <span> Mission & Vision</span>
              <h2>Creating Solutions for a Thriving Community.</h2>
              {/* Added Paragraphs for Mission & Vision */}
              <p>
                <p />
                Taisha St. Jean Tard is committed to creating a thriving
                community in Erie County's 2nd District. Her mission is to
                promote policies that drive economic growth, address resident
                needs, and strengthen community resources.
              </p>
              <p>
                With a vision focused on equity and opportunity, Taisha will
                bridge gaps in healthcare, enhance our environmental
                sustainability, and improve infrastructure across the district.
                Together, we can build a district where every voice matters!
              </p>
            </div>
          </div>
        </div>
        <div className="election-mission-wrap">
          <div className="row">
            {Mission.map((mvsion) => (
              <div
                className="col-lg-3 col-md-4 col-sm-6 col-12"
                key={mvsion.id}
              >
                <div className="election-mission-content">
                  <img src={mvsion.mImg} alt={mvsion.Title} />
                  <div className="title">{mvsion.Title}</div>
                  <div className="text">
                    <h3>{mvsion.Title}</h3>
                    <p>{mvsion.Des}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* Shape SVGs */}
      <div className="shape-1">
        <svg width="1245" height="1206" viewBox="0 0 1245 1206" fill="none">
          <path
            opacity="0.6"
            d="M0 0L1245 619V1206H0V0Z"
            fill="url(#paint0_linear_1_102)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_1_102"
              x1="622.5"
              y1="0"
              x2="622.5"
              y2="1206"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" stopColor="#F8F2F2" />
              <stop offset="1" stopColor="#F8F2F2" stopOpacity="0" />
            </linearGradient>
          </defs>
        </svg>
      </div>
      <div className="shape-2">
        <svg width="945" height="884" viewBox="0 0 945 884" fill="none">
          <path
            opacity="0.6"
            d="M945 0L0 503V884L945 359V0Z"
            fill="url(#paint0_linear_1_106)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_1_106"
              x1="945"
              y1="64"
              x2="661"
              y2="809"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" stopColor="#F8F2F2" />
              <stop offset="1" stopColor="#F8F2F2" stopOpacity="0" />
            </linearGradient>
          </defs>
        </svg>
      </div>
    </section>
  );
};

export default MissionVission;
